import { sortByName, sortAsc } from '../utils/sortOptions';
import { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import api from '../services/api';
import toast from 'react-hot-toast';
import {
  PlusIcon, XMarkIcon, PencilSquareIcon, CheckCircleIcon,
  TableCellsIcon, ListBulletIcon, DocumentDuplicateIcon,
} from '@heroicons/react/24/outline';

const ALL_DAYS = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'];
const DAYS     = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
const COLORS   = ['#3b6ef8','#10c98e','#8b5cf6','#f59e0b','#ef4444','#06b6d4','#ec4899','#14b8a6'];
const DAY_DOW  = { Monday:1, Tuesday:2, Wednesday:3, Thursday:4, Friday:5, Saturday:6, Sunday:0 };

const ACTIVITY_TYPES = [
  'Sports Period','Assembly','Arts & Crafts','Music','Drama','Library',
  'Computer Lab','Science Lab','Physical Education','Co-curricular Activity',
];
const ACTIVITY_COLOR = '#f97316';

function subjColor(s, arr) {
  if (!s) return '#9094a8';
  const i = arr.indexOf(s);
  return COLORS[i >= 0 ? i % COLORS.length : 0];
}

const css = `
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');
.tt { font-family:'Sora',sans-serif; color:#1a1d2e; animation:ttIn .35s ease both; position:relative; }
@keyframes ttIn { from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:none} }
.tt * { box-sizing:border-box; }
.tt-hdr { display:flex; align-items:flex-start; justify-content:space-between; margin-bottom:1.5rem; flex-wrap:wrap; gap:1rem; }
.tt-title { font-size:1.35rem; font-weight:700; color:#0f1123; letter-spacing:-.02em; }
.tt-sub   { font-size:.76rem; color:#9094a8; margin-top:3px; }
.btn { display:inline-flex; align-items:center; gap:7px; padding:9px 16px; border:none; border-radius:10px; font-family:'Sora',sans-serif; font-size:.8rem; font-weight:600; cursor:pointer; transition:all .18s; }
.btn svg { width:15px; height:15px; stroke-width:2; }
.btn-blue  { background:#3b6ef8; color:#fff; } .btn-blue:hover  { background:#2d5ef0; box-shadow:0 4px 14px rgba(59,110,248,.35); }
.btn-green { background:#10c98e; color:#fff; } .btn-green:hover { background:#0db87e; }
.btn-ghost { background:#f0f2f7; color:#6b7194; } .btn-ghost:hover { background:#e4e7f0; }
.btn-purple { background:#8b5cf6; color:#fff; } .btn-purple:hover { background:#7c3aed; }
.btn-sm { padding:6px 11px; font-size:.74rem; }
.btn:disabled { opacity:.5; cursor:not-allowed; }
.vtoggle { display:flex; gap:3px; background:#f0f2f7; border-radius:10px; padding:3px; }
.vbtn { display:inline-flex; align-items:center; gap:5px; padding:6px 12px; border-radius:8px; border:none; font-family:'Sora',sans-serif; font-size:.76rem; font-weight:600; cursor:pointer; background:transparent; color:#9094a8; transition:all .15s; }
.vbtn svg { width:13px; height:13px; stroke-width:2; }
.vbtn.on { background:#fff; color:#0f1123; box-shadow:0 1px 4px rgba(0,0,0,.1); }
.gtabs { display:flex; gap:6px; flex-wrap:wrap; margin-bottom:1rem; }
.gtab { padding:7px 18px; border-radius:10px; border:1.5px solid #e0e4f0; background:#fff; font-family:'Sora',sans-serif; font-size:.8rem; font-weight:600; cursor:pointer; color:#6b7194; transition:all .15s; white-space:nowrap; }
.gtab:hover { border-color:#3b6ef8; color:#3b6ef8; }
.gtab.on { background:#3b6ef8; color:#fff; border-color:#3b6ef8; box-shadow:0 4px 12px rgba(59,110,248,.2); }
.stabs { display:flex; gap:4px; background:#f0f2f7; border-radius:11px; padding:4px; margin-bottom:1.2rem; width:fit-content; overflow-x:auto; }
.stab { padding:6px 20px; border-radius:8px; border:none; font-family:'Sora',sans-serif; font-size:.78rem; font-weight:700; cursor:pointer; background:transparent; color:#9094a8; white-space:nowrap; }
.stab.on { background:#fff; color:#0f1123; box-shadow:0 1px 4px rgba(0,0,0,.12); }
.dtabs { display:flex; gap:4px; margin-bottom:1.2rem; overflow-x:auto; padding-bottom:4px; scrollbar-width:none; }
.dtabs::-webkit-scrollbar { display:none; }
.dtab { padding:5px 14px; border-radius:8px; border:1.5px solid #e0e4f0; background:#fff; font-family:'Sora',sans-serif; font-size:.74rem; font-weight:600; cursor:pointer; color:#9094a8; white-space:nowrap; flex-shrink:0; transition:all .15s; }
.dtab:hover { border-color:#3b6ef8; color:#3b6ef8; }
.dtab.on { background:#eef2ff; border-color:#3b6ef8; color:#3b6ef8; }
.dtab.off-tab { border-color:#fecaca; color:#ef4444; background:#fef2f2; }
.dtab.off-tab.on { background:#ef4444; color:white; border-color:#ef4444; }
.dtab.hol-tab { border-color:#a7f3d0; color:#10c98e; background:#ecfdf5; }
.panel { background:#fff; border-radius:16px; border:1px solid #e8ebf4; overflow:hidden; margin-bottom:1rem; }
.panel-hdr { display:flex; align-items:center; justify-content:space-between; padding:14px 18px; border-bottom:1px solid #f0f2f8; flex-wrap:wrap; gap:8px; }
.panel-title { font-size:.86rem; font-weight:600; color:#1a1d2e; }
.lt { width:100%; border-collapse:collapse; }
.lt thead { background:#fafbff; border-bottom:1px solid #edf0f9; }
.lt th { padding:10px 16px; text-align:center !important; font-size:.65rem; font-weight:700; color:#9094a8; text-transform:uppercase; letter-spacing:.07em; white-space:nowrap; }
.lt tbody tr { border-bottom:1px solid #f3f5fb; transition:background .12s; }
.lt tbody tr:last-child { border-bottom:none; }
.lt tbody tr:hover { background:#fafbff; }
.lt td { padding:11px 16px; font-size:.8rem; vertical-align:middle; text-align:center !important; }
.lt tr.off-row td  { background:#fef9f9; }
.lt tr.hol-row td  { background:#f0fdf4; }
.lt tr.sun-row td  { background:#f8f9fc; }
.pbadge { display:inline-flex; align-items:center; justify-content:center; width:28px; height:28px; border-radius:8px; background:#eef2ff; color:#3b6ef8; font-size:.76rem; font-weight:700; font-family:'JetBrains Mono',monospace; }
.pbadge.act { background:#fff7ed; color:#f97316; }
.dbadge { display:inline-flex; font-size:.72rem; font-weight:600; padding:3px 9px; border-radius:99px; }
.tcell  { font-size:.74rem; font-family:'JetBrains Mono',monospace; color:#6b7194; white-space:nowrap; }
.act-badge { display:inline-flex; align-items:center; gap:4px; font-size:.72rem; font-weight:700; padding:3px 9px; border-radius:99px; background:#fff7ed; color:#f97316; border:1px solid #fed7aa; }
.gwrap { overflow-x:auto; -webkit-overflow-scrolling:touch; width:100%; }
.gt { border-collapse:collapse; min-width:600px; table-layout:fixed; }
.gt th { padding:10px 12px; font-size:.67rem; font-weight:700; color:#9094a8; text-transform:uppercase; letter-spacing:.06em; background:#fafbff; border:1px solid #edf0f9; text-align:center !important; white-space:nowrap; }
.gt th.dh { background:#f0f2f7; text-align:left; padding-left:14px; width:100px; min-width:90px; color:#6b7194; }
.gt th.lh { background:#fffbeb; color:#92400e; min-width:80px; }
.gt td { border:1px solid #edf0f9; padding:6px 8px; vertical-align:top; width:130px; min-width:110px; height:72px; text-align:center !important; }
.gt td.dc     { background:#f8f9fc; font-weight:700; font-size:.82rem; color:#0f1123; white-space:nowrap; vertical-align:middle; padding:10px 14px; border-right:2px solid #e8ebf4; }
.gt td.off-dc { background:#fef9f9; color:#ef4444; font-weight:700; font-size:.82rem; vertical-align:middle; padding:10px 14px; border-right:2px solid #e8ebf4; }
.gt td.hol-dc { background:#f0fdf4; color:#10c98e; font-weight:700; font-size:.82rem; vertical-align:middle; padding:10px 14px; border-right:2px solid #e8ebf4; }
.gt td.sun-dc { background:#f8f9fc; color:#9094a8; font-weight:700; font-size:.82rem; vertical-align:middle; padding:10px 14px; border-right:2px solid #e8ebf4; }
.gt td.lc { background:#fffbeb; text-align:center; vertical-align:middle; }
.gt td.ec { text-align:center; color:#e0e4f0; font-size:.8rem; vertical-align:middle; }
.gt td.off-cell { background:#fef9f9; vertical-align:middle; text-align:center; }
.gt td.hol-cell { background:#f0fdf4; vertical-align:top; padding:6px 8px; }
.gt td.sun-cell { background:#f8f9fc; vertical-align:middle; text-align:center; }
.ge { border-radius:8px; padding:6px 8px; margin-bottom:3px; }
.ge:last-child { margin-bottom:0; }
.ge-s { font-size:.76rem; font-weight:700; line-height:1.2; }
.ge-t { font-size:.66rem; margin-top:2px; }
.ge-tm { font-size:.62rem; font-family:'JetBrains Mono',monospace; margin-top:2px; }
.hol-chip { display:flex; align-items:center; gap:5px; padding:5px 8px; border-radius:8px; background:#dcfce7; border-left:3px solid #10c98e; margin-bottom:3px; }
.hol-chip-name { font-size:.72rem; font-weight:700; color:#065f46; }
.hol-chip-date { font-size:.62rem; color:#10c98e; font-family:'JetBrains Mono',monospace; }
.mob-grid { display:none; }
.lt-cards { display:none; }
.day-card { background:#fff; border-radius:12px; border:1px solid #e8ebf4; margin-bottom:10px; overflow:hidden; }
.day-card.off-card { border-color:#fecaca; }
.day-card.hol-card { border-color:#a7f3d0; }
.day-card.sun-card { border-color:#e0e4f0; }
.day-card-hdr { display:flex; align-items:center; justify-content:space-between; padding:10px 14px; background:#f8f9fc; border-bottom:1px solid #edf0f9; }
.day-card.off-card .day-card-hdr { background:#fef9f9; }
.day-card.hol-card .day-card-hdr { background:#f0fdf4; }
.day-card.sun-card .day-card-hdr { background:#f8f9fc; }
.day-card-name  { font-size:.86rem; font-weight:700; color:#0f1123; }
.day-card-badge { font-size:.7rem; font-weight:600; padding:2px 8px; border-radius:99px; }
.period-pill { display:flex; align-items:center; gap:10px; padding:10px 14px; border-bottom:1px solid #f3f5fb; }
.period-pill:last-child { border-bottom:none; }
.period-num  { display:inline-flex; align-items:center; justify-content:center; width:26px; height:26px; border-radius:7px; background:#eef2ff; color:#3b6ef8; font-size:.72rem; font-weight:700; font-family:'JetBrains Mono',monospace; flex-shrink:0; }
.period-num.act { background:#fff7ed; color:#f97316; }
.period-info { flex:1; }
.period-subj { font-size:.82rem; font-weight:700; }
.period-meta { font-size:.7rem; color:#6b7194; margin-top:2px; }
.lunch-pill { display:flex; align-items:center; gap:8px; padding:8px 14px; background:#fffbeb; border-bottom:1px solid #fde68a; font-size:.78rem; font-weight:600; color:#92400e; }
.off-pill  { padding:12px 14px; font-size:.78rem; color:#ef4444; font-weight:600; background:#fef9f9; }
.sun-pill  { padding:12px 14px; font-size:.78rem; color:#9094a8; font-style:italic; background:#f8f9fc; }
.hol-pill  { padding:8px 14px; font-size:.78rem; background:#f0fdf4; border-bottom:1px solid #a7f3d0; }
.empty { text-align:center; padding:3rem 2rem; color:#9094a8; font-size:.82rem; }
.loading { display:flex; align-items:center; justify-content:center; height:200px; gap:10px; color:#9094a8; }
.spin { width:18px; height:18px; border:2px solid #e4e7f0; border-top-color:#3b6ef8; border-radius:50%; animation:sp .7s linear infinite; }
@keyframes sp { to{transform:rotate(360deg)} }
.mb { position:fixed; top:0; left:0; right:0; bottom:0; background:rgba(10,12,28,.65); backdrop-filter:blur(5px); display:flex; align-items:center; justify-content:center; z-index:9999; padding:20px; }
.mo { background:#fff; border-radius:20px; width:100%; max-width:1100px; max-height:90vh; display:flex; flex-direction:column; box-shadow:0 25px 60px rgba(0,0,0,.35); animation:mo .25s ease; overflow:hidden; }
@keyframes mo { from{opacity:0;transform:scale(.94)} to{opacity:1;transform:scale(1)} }
.mo-hd { display:flex; align-items:center; justify-content:space-between; padding:18px 22px; border-bottom:1px solid #f0f2f8; gap:8px; flex-wrap:wrap; }
.mo-title { font-size:1rem; font-weight:700; color:#0f1123; }
.mo-x { width:28px; height:28px; border-radius:7px; border:none; background:#f0f2f7; cursor:pointer; display:flex; align-items:center; justify-content:center; }
.mo-x svg { width:14px; height:14px; stroke-width:2; }
.mo-bd { padding:20px 22px; flex:1; overflow-y:auto; }
.mo-ft { display:flex; gap:8px; justify-content:flex-end; padding:14px 22px; border-top:1px solid #f0f2f8; flex-wrap:wrap; }
.edt { display:block; }
.mob { display:none; }
.ehdr { display:grid; grid-template-columns:44px 110px 88px 1.2fr 130px 130px 1.6fr 36px; gap:8px; padding:0 0 8px; border-bottom:1px solid #eaecf4; margin-bottom:8px; }
.ehdr span { font-size:.65rem; font-weight:700; color:#9094a8; text-transform:uppercase; letter-spacing:.07em; text-align:center; display:block; width:100%; }
.erow { display:grid; grid-template-columns:44px 110px 88px 1.2fr 130px 130px 1.6fr 36px; gap:8px; align-items:start; margin-bottom:8px; padding:8px; border-radius:10px; border:1.5px solid #e8ebf4; background:#fafbff; transition:border-color .15s; }
.erow.act-row { border-color:#fed7aa; background:#fff9f5; }
.ei,.es { font-family:'Sora',sans-serif; font-size:.78rem; padding:7px 10px; border:1.5px solid #e0e4f0; border-radius:8px; background:#f8f9fc; color:#1a1d2e; outline:none; width:100%; }
.ei:focus,.es:focus { border-color:#3b6ef8; background:#fff; }
.es.off-sel { border-color:#fecaca; background:#fef2f2; }
.es.act-sel { border-color:#fed7aa; background:#fff7ed; color:#c2410c; }
.erm { width:28px; height:28px; border:1px solid #fecaca; border-radius:7px; background:#fef2f2; color:#ef4444; cursor:pointer; display:flex; align-items:center; justify-content:center; flex-shrink:0; margin-top:1px; }
.erm svg { width:12px; height:12px; stroke-width:2; }
.ecard { background:#fafbff; border-radius:10px; border:1px solid #e8ebf4; padding:11px 12px; margin-bottom:8px; }
.ecard.off-ecard { border-color:#fecaca; background:#fef9f9; }
.ecard.act-ecard { border-color:#fed7aa; background:#fff9f5; }
.ecr { display:grid; grid-template-columns:1fr 1fr; gap:8px; margin-bottom:8px; }
.ecf { display:flex; flex-direction:column; gap:4px; }
.ecl { font-size:.63rem; font-weight:700; color:#9094a8; text-transform:uppercase; letter-spacing:.06em; }
.ecfull { grid-column:1/-1; }
.ecft { display:flex; justify-content:flex-end; margin-top:4px; }
.addbtn { display:inline-flex; align-items:center; gap:6px; padding:7px 14px; border-radius:9px; background:#ecfdf5; color:#10c98e; border:1px solid #a7f3d0; font-size:.78rem; font-weight:600; font-family:'Sora',sans-serif; cursor:pointer; margin-top:6px; }
.addbtn:hover { background:#d1fae5; }
.addbtn svg { width:13px; height:13px; stroke-width:2.5; }
.addactbtn { display:inline-flex; align-items:center; gap:6px; padding:7px 14px; border-radius:9px; background:#fff7ed; color:#f97316; border:1px solid #fed7aa; font-size:.78rem; font-weight:600; font-family:'Sora',sans-serif; cursor:pointer; margin-top:6px; margin-left:8px; }
.addactbtn:hover { background:#ffedd5; }
.addactbtn svg { width:13px; height:13px; stroke-width:2.5; }
.copybtn { display:inline-flex; align-items:center; gap:6px; padding:7px 14px; border-radius:9px; background:#f3f0ff; color:#8b5cf6; border:1px solid #ddd6fe; font-size:.78rem; font-weight:600; font-family:'Sora',sans-serif; cursor:pointer; margin-top:6px; margin-left:8px; }
.copybtn:hover { background:#ede9fe; }
.copybtn svg { width:13px; height:13px; stroke-width:2.5; }
.ln { background:#fffbeb; border:1px solid #fde68a; border-radius:9px; padding:9px 12px; margin-bottom:12px; font-size:.76rem; color:#92400e; display:flex; align-items:center; gap:8px; }
.off-warn { background:#fef2f2; border:1px solid #fecaca; border-radius:9px; padding:9px 12px; margin-bottom:12px; font-size:.76rem; color:#ef4444; display:flex; align-items:center; gap:8px; }
.off-day-tag { font-size:.6rem; font-weight:700; color:#ef4444; background:#fef2f2; border:1px solid #fecaca; border-radius:4px; padding:1px 5px; display:inline-block; margin-top:2px; }
.copy-info { background:#f3f0ff; border:1px solid #ddd6fe; border-radius:9px; padding:9px 12px; margin-bottom:12px; font-size:.76rem; color:#6d28d9; display:flex; align-items:center; gap:8px; }
.type-toggle { display:flex; gap:4px; }
.type-btn { padding:5px 9px; border-radius:7px; border:1.5px solid #e0e4f0; background:#f8f9fc; font-size:.7rem; font-weight:700; font-family:'Sora',sans-serif; cursor:pointer; color:#9094a8; transition:all .15s; white-space:nowrap; }
.type-btn.on-normal { background:#eef2ff; border-color:#3b6ef8; color:#3b6ef8; }
.type-btn.on-activity { background:#fff7ed; border-color:#f97316; color:#f97316; }
@media(max-width:768px) {
  .tt-title { font-size:1.1rem; }
  .gwrap { display:none; }
  .mob-grid { display:block; }
  .lt-wrap { display:none !important; }
  .lt-cards { display:block; padding:10px; }
  .edt { display:none !important; }
  .mob { display:block; }
  .mo-ft { justify-content:stretch; }
  .mo-ft .btn { flex:1; justify-content:center; }
  .mo-bd { padding:14px 16px; max-height:60vh; }
  .ecr { grid-template-columns:1fr; }
  .ecfull { grid-column:1; }
  .mo { border-radius:16px; margin:0; }
  .mo-hd { padding:14px 16px; }
  .mo-ft { padding:12px 16px; }
  .mb { padding:0 10px; align-items:flex-end; }
  .mo { max-width:100%; border-radius:16px 16px 0 0; max-height:95vh; }
}
`;

const fmtTime = (t) => {
  if (!t) return '';
  const [h,m] = t.split(':').map(Number);
  const ampm = h >= 12 ? 'PM' : 'AM';
  const h12  = h % 12 || 12;
  return `${h12}:${String(m).padStart(2,'0')} ${ampm}`;
};

const fmtShort = (d) => d
  ? new Date(d).toLocaleDateString('en-GB', { day:'2-digit', month:'short' })
  : '—';

export default function Timetable() {
  const [classes,        setClasses]        = useState([]);
  const [teachers,       setTeachers]       = useState([]);
  const [staff,          setStaff]          = useState([]);
  const [loading,        setLoading]        = useState(true);
  const [activeGrade,    setActiveGrade]    = useState(null);
  const [activeSection,  setActiveSection]  = useState('');
  const [activeDay,      setActiveDay]      = useState('All');
  const [editOpen,       setEditOpen]       = useState(false);
  const [editRows,       setEditRows]       = useState([]);
  const [saving,         setSaving]         = useState(false);
  const [view,           setView]           = useState('list');
  const [lunchStart,     setLunchStart]     = useState('');
  const [lunchEnd,       setLunchEnd]       = useState('');
  const [weeklyOffDays,  setWeeklyOffDays]  = useState([0]);
  const [saturdayPolicy, setSaturdayPolicy] = useState('all_off');
  const [holidays,       setHolidays]       = useState([]);
  const [copyDone,       setCopyDone]       = useState(false);
  const [allSubjects,    setAllSubjects]    = useState([]);
  const activeGradeRef = useRef(null);

  useEffect(() => {
    activeGradeRef.current = activeGrade;
    if (activeGrade) api.get('/admin/classes/subjects').then(r => { if (Array.isArray(r.data)) setAllSubjects(r.data); }).catch(()=>{});
  }, [activeGrade?._id]);

  useEffect(() => {
    Promise.all([
      api.get('/admin/classes'),
      api.get('/admin/teachers?limit=100'),
      api.get('/admin/salary/non-portal-staff?limit=200'),
      api.get('/admin/settings/school'),
      api.get('/admin/holidays/settings'),
      api.get(`/admin/holidays?year=${new Date().getFullYear()}`),
    ]).then(([c, t, stf, s, hs, hols]) => {
      const cls  = c.data || [];
      const tch  = t.data?.teachers || [];
      const stfData = Array.isArray(stf.data) ? stf.data.filter(s => s.isActive !== false && !s.exitType) : [];
      setStaff(stfData);
      const sch  = s.data;
      const hset = hs.data;
      setClasses(cls);
      setTeachers(tch);
      setLunchStart(sch?.settings?.lunchBreakStart || '');
      const rawEnd = sch?.settings?.lunchBreakEnd || '';
      setLunchEnd(rawEnd === '00:00' ? '' : rawEnd);
      setView(sch?.settings?.timetableView || 'list');
      setWeeklyOffDays(hset?.weeklyOffDays  || [0]);
      setSaturdayPolicy(hset?.saturdayPolicy || 'all_off');
      setHolidays(Array.isArray(hols.data) ? hols.data : []);
      if (cls.length) {
        const firstCls = sortByName(cls)[0];
        setActiveGrade(firstCls);
        setActiveSection(sortAsc(firstCls.sections || [])[0] || '');
      }
    }).catch(() => toast.error('Failed to load')).finally(() => setLoading(false));
    api.get('/admin/classes/subjects').then(r => { if (Array.isArray(r.data)) setAllSubjects(r.data); }).catch(()=>{});
  }, []);

  const isOffDay = (dayName) => {
    if (dayName === 'Sunday')   return true;
    if (dayName === 'Saturday') return saturdayPolicy === 'all_off';
    const dow = DAY_DOW[dayName];
    return (weeklyOffDays || []).filter(d => d !== 6).includes(dow);
  };

  const satNote = (dayName) => {
    if (dayName !== 'Saturday') return null;
    if (saturdayPolicy === 'alternate_odd_off')  return '1st & 3rd off';
    if (saturdayPolicy === 'alternate_even_off') return '2nd & 4th off';
    return null;
  };

  const holidaysByDay = {};
  holidays.forEach(h => {
    const dow = new Date(h.date).getDay();
    const day = ALL_DAYS.find(d => DAY_DOW[d] === dow);
    if (day) {
      if (!holidaysByDay[day]) holidaysByDay[day] = [];
      holidaysByDay[day].push(h);
    }
  });

  const getDayType = (day) => {
    if (day === 'Sunday')  return 'sunday';
    if (isOffDay(day))     return 'off';
    if (holidaysByDay[day]?.length) return 'holiday';
    return 'normal';
  };

  const tMap = {};
  teachers.forEach(t => { tMap['T:' + String(t._id)] = t.user?.name || '—'; tMap[String(t._id)] = t.user?.name || '—'; });
  const sMap = {};
  staff.forEach(s => { sMap['S:' + String(s._id)] = s.name || '—'; });
  const tName = (t) => {
    if (!t) return '—';
    if (typeof t === 'object') return t.user?.name || tMap[String(t._id)] || '—';
    if (String(t).startsWith('T:')) return tMap[String(t)] || '—';
    if (String(t).startsWith('S:')) return sMap[String(t)] || '—';
    return tMap[String(t)] || '—';
  };

  const allE       = activeGrade?.timetable || [];
  const secE       = allE.filter(e => String(e.section || '') === String(activeSection));
  const uniqSubjs  = [...new Set(secE.filter(e => !e.isActivity).map(e => e.subject).filter(Boolean))];
  const classSubjects = allSubjects.length > 0 ? allSubjects : (activeGrade?.subjects || []);

  const listDays = activeDay === 'All' ? ALL_DAYS : [activeDay];

  const dayRows = (day) => {
    const type = getDayType(day);
    const dayE = secE.filter(e => e.day === day).sort((a,b) => (a.period||0)-(b.period||0));
    return { type, entries: dayE, holidays: holidaysByDay[day]||[] };
  };

  const allPeriods = [...new Set(secE.map(e => e.period))].sort((a,b) => a-b);
  const gridMap    = {};
  secE.forEach(e => {
    if (!gridMap[e.period]) gridMap[e.period] = {};
    if (!gridMap[e.period][e.day]) gridMap[e.period][e.day] = [];
    gridMap[e.period][e.day].push(e);
  });

  const lunchIdx = () => {
    if (!lunchStart || !allPeriods.length) return -1;
    const [lh, lm] = lunchStart.split(':').map(Number);
    for (let i = 0; i < allPeriods.length - 1; i++) {
      const cur = secE.find(e => e.period === allPeriods[i]   && e.endTime);
      const nxt = secE.find(e => e.period === allPeriods[i+1] && e.startTime);
      if (cur && nxt) {
        const [ch, cm] = cur.endTime.split(':').map(Number);
        const [nh, nm] = nxt.startTime.split(':').map(Number);
        if (ch*60+cm <= lh*60+lm && lh*60+lm <= nh*60+nm) return i;
      }
    }
    return -1;
  };
  const lunchAfter = lunchIdx();

  const cols = [];
  allPeriods.forEach((p, i) => {
    cols.push({ t:'p', p });
    if (i === lunchAfter) cols.push({ t:'l' });
  });

  const periodTime = (p) => {
    const e = secE.find(x => x.period === p && x.startTime);
    if (!e) return null;
    return e.endTime ? `${e.startTime}–${e.endTime}` : e.startTime;
  };

  async function openEdit() {
    try {
      const gradeId = activeGradeRef.current?._id || activeGrade?._id;
      const { data: freshClasses } = await api.get('/admin/classes');
      const latestGrade = (freshClasses || []).find(c => String(c._id) === String(gradeId));
      if (latestGrade) { setClasses(freshClasses); setActiveGrade(latestGrade); activeGradeRef.current = latestGrade; }
      const latestTimetable = latestGrade?.timetable || [];
      const latestSecE = latestTimetable.filter(e => String(e.section || '') === String(activeSection));
      const rows = latestSecE.length > 0
        ? latestSecE.map(e => ({ period:e.period||1, day:e.day||'Monday', startTime:e.startTime||'', endTime:e.endTime||'', subject:e.subject||'', teacher:typeof e.teacher==='object'?String(e.teacher?._id||''):String(e.teacher||''), isActivity:e.isActivity||false, activityType:e.activityType||'' }))
        : [{ period:1, day:'Monday', startTime:'', endTime:'', subject:'', teacher:'', isActivity:false, activityType:'' }];
      setEditRows(rows); setCopyDone(false); setEditOpen(true);
    } catch {
      const rows = secE.length > 0
        ? secE.map(e => ({ period:e.period||1, day:e.day||'Monday', startTime:e.startTime||'', endTime:e.endTime||'', subject:e.subject||'', teacher:typeof e.teacher==='object'?String(e.teacher?._id||''):String(e.teacher||''), isActivity:e.isActivity||false, activityType:e.activityType||'' }))
        : [{ period:1, day:'Monday', startTime:'', endTime:'', subject:'', teacher:'', isActivity:false, activityType:'' }];
      setEditRows(rows); setCopyDone(false); setEditOpen(true);
    }
  }

  const addHour = (t) => { if (!t) return ''; const [h,m]=t.split(':').map(Number); return `${String((h+1)%24).padStart(2,'0')}:${String(m).padStart(2,'0')}`; };

  const toMins = (t) => { if(!t) return 0; const [h,m]=t.split(':').map(Number); return h*60+m; };
  const fromMins = (m) => `${String(Math.floor(m/60)).padStart(2,'0')}:${String(m%60).padStart(2,'0')}`;

  const skipLunch = (startTime) => {
    if (!startTime||!lunchStart||!lunchEnd) return startTime;
    const sMins=toMins(startTime), lsMins=toMins(lunchStart), leMins=toMins(lunchEnd);
    if (sMins>=lsMins&&sMins<leMins) return lunchEnd;
    return startTime;
  };

  // Adjust end time if it falls inside or before end of lunch
  const adjustEndForLunch = (startTime, endTime) => {
    if (!endTime||!lunchStart||!lunchEnd) return endTime;
    const sMins=toMins(startTime), eMins=toMins(endTime);
    const lsMins=toMins(lunchStart), leMins=toMins(lunchEnd);
    // If end falls inside lunch, push it past lunch by same duration
    if (eMins>lsMins&&eMins<=leMins) {
      const dur = eMins - sMins;
      return fromMins(toMins(lunchEnd) + Math.max(0, dur - (lsMins - sMins)));
    }
    return endTime;
  };

  const upd = (i, f, v) => setEditRows(prev => {
    const next = prev.map((r,k) => k===i?{...r,[f]:v}:r);
    if (f==='startTime'&&v) {
      const adj=skipLunch(v);
      if(adj!==v) next[i]={...next[i],startTime:adj};
      const autoEnd = addHour(adj);
      const newEnd = adjustEndForLunch(adj, next[i].endTime || autoEnd);
      if(!next[i].endTime) next[i]={...next[i],endTime:newEnd};
      else next[i]={...next[i],endTime:newEnd};
      if(i+1<next.length&&!next[i+1].startTime) next[i+1]={...next[i+1],startTime:next[i].endTime||autoEnd};
    }
    if(f==='endTime'&&v) {
      const adjEnd = adjustEndForLunch(next[i].startTime, v);
      if(adjEnd!==v) next[i]={...next[i],endTime:adjEnd};
      if(i+1<next.length&&!next[i+1].startTime) next[i+1]={...next[i+1],startTime:adjEnd||v};
    }
    return next;
  });

  const add = () => setEditRows(prev => { const last=prev[prev.length-1]; const ns=skipLunch(last?.endTime||''); const ne=ns?addHour(ns):''; return [...prev,{period:prev.length+1,day:last?.day||'Monday',startTime:ns,endTime:ne,subject:'',teacher:'',isActivity:false,activityType:''}]; });
  const addActivity = () => setEditRows(prev => { const last=prev[prev.length-1]; const ns=skipLunch(last?.endTime||''); const ne=ns?addHour(ns):''; return [...prev,{period:prev.length+1,day:last?.day||'Monday',startTime:ns,endTime:ne,subject:'',teacher:'',isActivity:true,activityType:'Sports Period'}]; });
  const del = (i) => setEditRows(prev => prev.filter((_,k)=>k!==i));
  const toggleType = (i) => setEditRows(prev => prev.map((r,k)=>k!==i?r:{...r,isActivity:!r.isActivity,activityType:!r.isActivity?'Sports Period':'',subject:!r.isActivity?'':r.subject,teacher:!r.isActivity?'':r.teacher}));

  const copyMondayToAll = () => {
    const mondayRows=editRows.filter(r=>r.day==='Monday');
    if(!mondayRows.length){toast.error('No Monday periods to copy');return;}
    const workingDays=DAYS.filter(d=>d!=='Monday'&&!isOffDay(d));
    if(!workingDays.length){toast.error('No other working days to copy to');return;}
    const newRows=[...editRows.filter(r=>r.day==='Monday')];
    workingDays.forEach(day=>mondayRows.forEach(r=>newRows.push({...r,day})));
    setEditRows(newRows); setCopyDone(true);
    toast.success(`Copied ${mondayRows.length} period${mondayRows.length!==1?'s':''} to ${workingDays.join(', ')}`);
  };

  async function save() {
    try {
      setSaving(true);
      const offEntries=editRows.filter(r=>(r.subject.trim()||r.isActivity)&&isOffDay(r.day));
      if(offEntries.length){const offDays=[...new Set(offEntries.map(r=>r.day))].join(', ');toast.error(`Cannot schedule periods on off days: ${offDays}`);return;}
      const gradeId=activeGradeRef.current?._id||activeGrade?._id;
      const{data:freshClasses}=await api.get('/admin/classes');
      const latestGrade=(freshClasses||[]).find(c=>String(c._id)===String(gradeId));
      const latestTimetable=latestGrade?.timetable||[];
      const others=latestTimetable.filter(e=>String(e.section||'')!==String(activeSection)).map(e=>({section:e.section||'',period:e.period,day:e.day,subject:e.subject,startTime:e.startTime||'',endTime:e.endTime||'',teacher:typeof e.teacher==='object'?(e.teacher?._id||null):(e.teacher||null),isActivity:e.isActivity||false,activityType:e.activityType||''}));
      const mine=editRows.filter(r=>(r.subject.trim()||r.isActivity)&&!isOffDay(r.day)).map(r=>({section:activeSection,period:Number(r.period),day:r.day,startTime:r.startTime||'',endTime:r.endTime||'',subject:r.isActivity?'':r.subject.trim(),teacher:r.teacher||null,isActivity:r.isActivity||false,activityType:r.isActivity?(r.activityType||''):''}));
      await api.post(`/admin/classes/${gradeId}/timetable`,{timetable:[...others,...mine]});
      const{data:updatedClasses}=await api.get('/admin/classes');
      setClasses(updatedClasses||[]);
      const updatedGrade=(updatedClasses||[]).find(c=>String(c._id)===String(gradeId));
      if(updatedGrade) setActiveGrade(updatedGrade);
      toast.success(`Saved: ${activeGrade?.name} — Section ${activeSection}`);
      setEditOpen(false);
    } catch{toast.error('Failed to save');}
    finally{setSaving(false);}
  }

  const hasOffRows=editRows.some(r=>(r.subject.trim()||r.isActivity)&&isOffDay(r.day));
  const mondayCount=editRows.filter(r=>r.day==='Monday'&&(r.subject.trim()||r.isActivity)).length;

  const getPersonnelOptions = (row) => {
    if (!row.isActivity) return teachers.map(t=>({value:String(t._id),label:t.user?.name||'—',group:'Teachers'}));
    const actType=(row.activityType||'').toLowerCase();
    const isSports=actType.includes('sport')||actType.includes('pe')||actType.includes('physical')||actType.includes('fitness')||actType.includes('swimming')||actType.includes('coach');
    const isMedical=actType.includes('medical')||actType.includes('health')||actType.includes('first aid');
    const relevantStaff=staff.filter(s=>{if(isSports) return s.department==='Sports'; if(isMedical) return s.department==='Medical'; return true;});
    return [...teachers.map(t=>({value:'T:'+String(t._id),label:t.user?.name||'—',group:'Teachers'})),...relevantStaff.map(s=>({value:'S:'+String(s._id),label:s.name+' ('+s.designation+')',group:s.department+' Staff'}))];
  };

  const SubjectInput = ({ value, onChange, className }) => {
    if (classSubjects.length > 0) {
      return (
        <select className={className||'es'} value={value} onChange={e=>onChange(e.target.value)}>
          <option value="">— Select Subject —</option>
          {classSubjects.map(s=><option key={s} value={s}>{s}</option>)}
          <option value="__other__">Other (type below)</option>
        </select>
      );
    }
    return <input type="text" className={className||'ei'} value={value} placeholder="e.g. Maths" onChange={e=>onChange(e.target.value)}/>;
  };

  const SubjectField = ({ row, i, className }) => {
    const showOther=classSubjects.length>0&&row.subject&&!classSubjects.includes(row.subject);
    return (
      <div style={{display:'flex',flexDirection:'column',gap:4}}>
        <SubjectInput value={classSubjects.includes(row.subject)||!row.subject?row.subject:(classSubjects.length>0?'__other__':row.subject)} onChange={v=>{if(v==='__other__') upd(i,'subject',''); else upd(i,'subject',v);}} className={className}/>
        {showOther&&<input type="text" className="ei" value={row.subject} placeholder="Type subject name" onChange={e=>upd(i,'subject',e.target.value)}/>}
      </div>
    );
  };

  const PersonnelSelect = ({ row, i }) => {
    const opts=getPersonnelOptions(row);
    const groups=[...new Set(opts.map(o=>o.group))];
    return (
      <select className={`es${row.isActivity?' act-sel':''}`} value={row.teacher||''} onChange={e=>upd(i,'teacher',e.target.value)}>
        <option value="">{row.isActivity?'— Assign (optional) —':'— No teacher —'}</option>
        {groups.map(g=>(
          <optgroup key={g} label={g}>
            {opts.filter(o=>o.group===g).map(o=><option key={o.value} value={o.value}>{o.label}</option>)}
          </optgroup>
        ))}
      </select>
    );
  };

  return (
    <div className="tt">
      <style>{css}</style>
      <div className="tt-hdr">
        <div><div className="tt-title">Timetable</div><div className="tt-sub">Manage timetables by grade and section</div></div>
        <div style={{display:'flex',gap:8,flexWrap:'wrap',alignItems:'center'}}>
          <div className="vtoggle">
            <button className={`vbtn${view==='list'?' on':''}`} onClick={()=>setView('list')}><ListBulletIcon/>List</button>
            <button className={`vbtn${view==='grid'?' on':''}`} onClick={()=>setView('grid')}><TableCellsIcon/>Grid</button>
          </div>
          {activeGrade&&<button className="btn btn-blue" onClick={openEdit}><PencilSquareIcon/>Edit {activeGrade.name} — Sec {activeSection}</button>}
        </div>
      </div>

      {loading&&<div className="loading"><div className="spin"/>Loading…</div>}
      {!loading&&!classes.length&&<div className="empty">No classes found. Add classes first.</div>}

      {!loading&&classes.length>0&&(
        <>
          <div className="gtabs">
            {sortByName(classes).map(cls=>(
              <button key={cls._id} className={`gtab${activeGrade?._id===cls._id?' on':''}`}
                onClick={()=>{setActiveGrade(cls);setActiveSection(sortAsc(cls.sections||[])[0]||'');setActiveDay('All');}}>
                {cls.name}
              </button>
            ))}
          </div>

          {activeGrade?.sections?.length>0&&(
            <div className="stabs">
              {sortAsc(activeGrade.sections).map(sec=>(
                <button key={sec} className={`stab${activeSection===sec?' on':''}`}
                  onClick={()=>{setActiveSection(sec);setActiveDay('All');}}>
                  Section {sec}
                </button>
              ))}
            </div>
          )}

          {view==='list'&&(
            <div className="dtabs">
              <button className={`dtab${activeDay==='All'?' on':''}`} onClick={()=>setActiveDay('All')}>All</button>
              {ALL_DAYS.map(d=>{
                const type=getDayType(d);
                const cls2=type==='off'||type==='sunday'?' off-tab':type==='holiday'?' hol-tab':'';
                return <button key={d} className={`dtab${cls2}${activeDay===d?' on':''}`} onClick={()=>setActiveDay(d)}>{d.slice(0,3)}{type==='off'||type==='sunday'?' 📅':type==='holiday'?' 🎉':''}</button>;
              })}
            </div>
          )}

          <div className="panel">
            <div className="panel-hdr">
              <div className="panel-title">
                {activeGrade?.name} — Section {activeSection}
                {view==='list'&&activeDay!=='All'?` — ${activeDay}`:''}
                <span style={{fontWeight:400,color:'#9094a8',marginLeft:8,fontSize:'.76rem'}}>{secE.length} period{secE.length!==1?'s':''}</span>
              </div>
              <button className="btn btn-ghost btn-sm" onClick={openEdit}><PencilSquareIcon/>Edit</button>
            </div>

            {view==='list'&&(
              <div className="lt-wrap" style={{overflowX:'auto'}}>
                <table className="lt">
                  <thead><tr>
                    <th style={{minWidth:70}}>Period</th>
                    {activeDay==='All'&&<th style={{minWidth:100}}>Day</th>}
                    <th style={{minWidth:150}}>Time</th>
                    <th style={{minWidth:160}}>Subject / Activity</th>
                    <th style={{minWidth:130}}>Teacher</th>
                  </tr></thead>
                  <tbody>
                    {listDays.map(day=>{
                      const{type,entries:dayE,holidays:dayH}=dayRows(day);
                      const holRows=dayH.map((h,hi)=>(
                        <tr key={`hol-${day}-${hi}`} className="hol-row">
                          <td colSpan={activeDay==='All'?5:4}>
                            <div style={{display:'flex',alignItems:'center',gap:8,justifyContent:'center'}}>
                              <span>🎉</span>
                              <span style={{fontWeight:700,color:'#065f46',fontSize:'.82rem'}}>{h.name}</span>
                              <span style={{fontSize:'.7rem',color:'#10c98e',fontFamily:"'JetBrains Mono',monospace"}}>{fmtShort(h.date)}</span>
                            </div>
                          </td>
                        </tr>
                      ));
                      if(type==='sunday'&&!dayE.length&&!dayH.length) return (
                        <tr key={`sun-${day}`} className="sun-row">
                          <td><span style={{color:'#c0c5dc',fontSize:'.72rem'}}>—</span></td>
                          {activeDay==='All'&&<td><span className="dbadge" style={{background:'#f0f2f7',color:'#9094a8'}}>{day}</span></td>}
                          <td></td><td><span style={{fontSize:'.74rem',fontWeight:600,color:'#9094a8'}}>📅 Sunday — Weekly Off</span></td><td></td>
                        </tr>
                      );
                      if(type==='off'&&!dayE.length&&!dayH.length) return (
                        <tr key={`off-${day}`} className="off-row">
                          <td><span style={{color:'#fecaca',fontSize:'.72rem'}}>—</span></td>
                          {activeDay==='All'&&<td><span className="dbadge" style={{background:'#fef2f2',color:'#ef4444'}}>{day}</span></td>}
                          <td></td>
                          <td><span style={{fontSize:'.74rem',fontWeight:600,color:'#ef4444'}}>📅 Weekly Off</span></td>
                          <td></td>
                        </tr>
                      );
                      const showDay=activeDay==='All';
                      // Build period rows with lunch inserted at correct position
                      const periodRows=[];
                      let lunchInserted=!lunchStart;
                      dayE.forEach((e,i)=>{
                        // Insert lunch before first period starting at/after lunchEnd
                        if(!lunchInserted&&e.startTime&&toMins(e.startTime)>=toMins(lunchEnd||lunchStart)){
                          periodRows.push(
                            <tr key={`lunch-${e.day}`} style={{background:'#fffbeb'}}>
                              <td colSpan={showDay?5:4} style={{padding:'8px 16px',fontSize:'.76rem',fontWeight:600,color:'#92400e'}}>
                                🍽 Lunch Break — {lunchStart}{lunchEnd?` – ${lunchEnd}`:''}
                              </td>
                            </tr>
                          );
                          lunchInserted=true;
                        }
                        if(e.isActivity){
                          periodRows.push(<tr key={`act-${e.day}-${i}`}>
                            <td><span className="pbadge act">🏃</span></td>
                            {showDay&&<td><span className="dbadge" style={{background:'#eef2ff',color:'#3b6ef8'}}>{e.day}</span></td>}
                            <td><span className="tcell">{e.startTime&&e.endTime?`${e.startTime} – ${e.endTime}`:e.startTime||e.endTime||'—'}</span></td>
                            <td><span className="act-badge">🏃 {e.activityType||'Activity'}</span></td>
                            <td style={{fontSize:'.78rem',color:'#4a5075'}}>{tName(e.teacher)||'—'}</td>
                          </tr>);
                        } else {
                          const color=subjColor(e.subject,uniqSubjs);
                          periodRows.push(<tr key={`per-${e.day}-${i}`}>
                            <td><span className="pbadge">{e.period}</span></td>
                            {showDay&&<td><span className="dbadge" style={{background:'#eef2ff',color:'#3b6ef8'}}>{e.day}</span></td>}
                            <td><span className="tcell">{e.startTime&&e.endTime?`${e.startTime} – ${e.endTime}`:e.startTime||e.endTime||'—'}</span></td>
                            <td><span style={{display:'inline-flex',fontSize:'.76rem',fontWeight:600,padding:'4px 10px',borderRadius:99,background:`${color}18`,color}}>{e.subject}</span></td>
                            <td style={{fontSize:'.78rem',color:'#4a5075'}}>{tName(e.teacher)}</td>
                          </tr>);
                        }
                      });
                      if(!dayE.length&&dayH.length) return holRows;
                      return [...holRows,...periodRows];
                    })}
                    {/* Lunch break shown inline at correct position via renderEntry */}
                  </tbody>
                </table>
              </div>
            )}

            {view==='list'&&(
              <div className="lt-cards">
                {listDays.map(day=>{
                  const{type,entries:dayE,holidays:dayH}=dayRows(day);
                  const cardCls=type==='sunday'?'day-card sun-card':type==='off'?'day-card off-card':type==='holiday'?'day-card hol-card':'day-card';
                  const badgeStyle=type==='sunday'?{background:'#f0f2f7',color:'#9094a8'}:type==='off'?{background:'#fef2f2',color:'#ef4444'}:type==='holiday'?{background:'#ecfdf5',color:'#10c98e'}:{background:'#eef2ff',color:'#3b6ef8'};
                  const items=[]; let lunchDone=!lunchStart;
                  dayE.forEach(e=>{
                    if(!lunchDone&&e.startTime){const[lh,lm]=lunchStart.split(':').map(Number);const[ph,pm]=e.startTime.split(':').map(Number);if(ph*60+pm>=lh*60+lm){items.push({type:'lunch'});lunchDone=true;}}
                    items.push({type:'period',e});
                  });
                  if(lunchStart&&!lunchDone&&dayE.length) items.push({type:'lunch'});
                  return (
                    <div key={day} className={cardCls}>
                      <div className="day-card-hdr"><span className="day-card-name">{day}</span><span className="day-card-badge" style={badgeStyle}>{type==='off'?'📅 Weekly Off':type==='sunday'?'📅 Off':type==='holiday'?'🎉 Holiday':`${dayE.length} period${dayE.length!==1?'s':''}`}</span></div>
                      {dayH.map((h,hi)=><div key={hi} className="hol-pill"><span style={{fontWeight:700,color:'#065f46'}}>🎉 {h.name}</span><span style={{fontSize:'.68rem',color:'#10c98e',fontFamily:"'JetBrains Mono',monospace",marginLeft:6}}>{fmtShort(h.date)}</span></div>)}
                      {(type==='off'||type==='sunday')&&!dayE.length&&!dayH.length&&<div className={type==='sunday'?'sun-pill':'off-pill'}>{type==='sunday'?'No classes — Sunday':'No classes scheduled'}</div>}
                      {items.map((item,idx)=>{
                        if(item.type==='lunch') return <div key="lunch" className="lunch-pill">🍽 Lunch {lunchStart&&`${lunchStart}${lunchEnd?` – ${lunchEnd}`:''}`}</div>;
                        const e=item.e;
                        if(e.isActivity) return (
                          <div key={idx} className="period-pill">
                            <span className="period-num act">🏃</span>
                            <div className="period-info">
                              <div className="period-subj" style={{color:ACTIVITY_COLOR}}>🏃 {e.activityType||'Activity'}</div>
                              <div className="period-meta">{tName(e.teacher)&&tName(e.teacher)!=='—'?tName(e.teacher)+' · ':''}{e.startTime&&<span style={{fontFamily:"'JetBrains Mono',monospace",fontSize:'.68rem'}}>{e.startTime}{e.endTime?` – ${e.endTime}`:''}</span>}</div>
                            </div>
                          </div>
                        );
                        const col=subjColor(e.subject,uniqSubjs);
                        return (
                          <div key={idx} className="period-pill">
                            <span className="period-num">{e.period}</span>
                            <div className="period-info">
                              <div className="period-subj" style={{color:col}}>{e.subject}</div>
                              <div className="period-meta">{tName(e.teacher)}{e.startTime&&<span style={{marginLeft:6,fontFamily:"'JetBrains Mono',monospace",fontSize:'.68rem'}}>{e.startTime}{e.endTime?` – ${e.endTime}`:''}</span>}</div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            )}

            {view==='grid'&&(
              <>
                <div className="gwrap">
                  <table className="gt">
                    <thead>
                      <tr>
                        <th className="dh">Day</th>
                        {cols.map((col,ci)=>{
                          if(col.t==='l') return <th key={`lh-${ci}`} className="lh">🍽 Lunch{lunchStart&&<div style={{fontSize:'.6rem',fontWeight:400,fontFamily:"'JetBrains Mono',monospace",marginTop:2}}>{lunchStart}{lunchEnd?` – ${lunchEnd}`:''}</div>}</th>;
                          return <th key={`ph-${col.p}`}><div>P{col.p}</div>{periodTime(col.p)&&<div style={{fontSize:'.6rem',fontWeight:400,fontFamily:"'JetBrains Mono',monospace",color:'#b0b5cc',marginTop:2}}>{periodTime(col.p)}</div>}</th>;
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {ALL_DAYS.map(day=>{
                        const type=getDayType(day); const dayHols=holidaysByDay[day]||[]; const off=type==='off'||type==='sunday';
                        const dcClass=type==='sunday'?'sun-dc':type==='off'?'off-dc':type==='holiday'?'hol-dc':'dc';
                        return (
                          <tr key={day}>
                            <td className={`dc ${dcClass}`}>
                              <div>{day}</div>
                              {type==='off'&&<div style={{fontSize:'.62rem',color:'#ef4444',fontWeight:600,marginTop:2}}>📅 Off</div>}
                              {type==='sunday'&&<div style={{fontSize:'.62rem',color:'#9094a8',marginTop:2}}>📅 Off</div>}
                              {type==='holiday'&&<div style={{fontSize:'.62rem',color:'#10c98e',fontWeight:600,marginTop:2}}>🎉 Holiday</div>}
                              {satNote(day)&&<div style={{fontSize:'.58rem',color:'#f59e0b',fontWeight:600,marginTop:1}}>{satNote(day)}</div>}
                            </td>
                            {off?(
                              <td colSpan={cols.length||1} className={type==='sunday'?'sun-cell':'off-cell'}>
                                <div style={{fontSize:'.76rem',fontWeight:600,color:type==='sunday'?'#9094a8':'#ef4444'}}>{type==='sunday'?'📅 Sunday — Weekly Off':'📅 Weekly Off'}</div>
                              </td>
                            ):cols.map((col,ci)=>{
                              if(col.t==='l') return <td key={`lc-${ci}-${day}`} className="lc"><span style={{fontSize:'.8rem'}}>🍽</span></td>;
                              const cellE=gridMap[col.p]?.[day]||[];
                              if(!cellE.length) return <td key={`ec-${col.p}-${day}`} className="ec" style={{color:'#d1d5db',fontSize:'.72rem',textAlign:'center',verticalAlign:'middle'}}>—</td>;
                              return (
                                <td key={`tc-${col.p}-${day}`}>
                                  {cellE.map((e,ei)=>{
                                    if(e.isActivity) return (
                                      <div key={ei} className="ge" style={{background:'#fff7ed',borderLeft:`3px solid ${ACTIVITY_COLOR}`,marginBottom:ei<cellE.length-1?3:0}}>
                                        <div className="ge-s" style={{color:ACTIVITY_COLOR}}>🏃 {e.activityType||'Activity'}</div>
                                        {e.teacher&&<div className="ge-t" style={{color:'#f97316cc'}}>{tName(e.teacher)}</div>}
                                        {e.startTime&&<div className="ge-tm" style={{color:'#f97316aa'}}>{e.startTime}{e.endTime?` – ${e.endTime}`:''}</div>}
                                      </div>
                                    );
                                    const c2=subjColor(e.subject,uniqSubjs);
                                    return (
                                      <div key={ei} className="ge" style={{background:`${c2}18`,borderLeft:`3px solid ${c2}`,marginBottom:ei<cellE.length-1?3:0}}>
                                        <div className="ge-s" style={{color:c2}}>{e.subject}</div>
                                        <div className="ge-t" style={{color:`${c2}cc`}}>{tName(e.teacher)}</div>
                                        {e.startTime&&<div className="ge-tm" style={{color:`${c2}99`}}>{e.startTime}{e.endTime?` – ${e.endTime}`:''}</div>}
                                      </div>
                                    );
                                  })}
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <div className="mob-grid" style={{padding:'10px'}}>
                  {ALL_DAYS.map(day=>{
                    const type=getDayType(day); const dayHols=holidaysByDay[day]||[]; const dayE=secE.filter(e=>e.day===day).sort((a,b)=>(a.period||0)-(b.period||0));
                    const cardCls=type==='sunday'?'day-card sun-card':type==='off'?'day-card off-card':type==='holiday'?'day-card hol-card':'day-card';
                    const badgeStyle=type==='sunday'?{background:'#f0f2f7',color:'#9094a8'}:type==='off'?{background:'#fef2f2',color:'#ef4444'}:type==='holiday'?{background:'#ecfdf5',color:'#10c98e'}:{background:'#eef2ff',color:'#3b6ef8'};
                    const items=[]; let lunchDone=false;
                    dayE.forEach(e=>{
                      if(!lunchDone&&lunchStart&&e.startTime){const[lh,lm]=lunchStart.split(':').map(Number);const[ph,pm]=e.startTime.split(':').map(Number);if(ph*60+pm>=lh*60+lm){items.push({type:'lunch'});lunchDone=true;}}
                      items.push({type:'period',e});
                    });
                    if(lunchStart&&!lunchDone&&dayE.length) items.push({type:'lunch'});
                    return (
                      <div key={day} className={cardCls}>
                        <div className="day-card-hdr"><span className="day-card-name">{day}</span><span className="day-card-badge" style={badgeStyle}>{type==='off'?'📅 Weekly Off':type==='sunday'?'📅 Off':type==='holiday'?'🎉 Holiday':`${dayE.length} period${dayE.length!==1?'s':''}`}</span></div>
                        {dayHols.map((h,hi)=><div key={hi} className="hol-pill"><span style={{fontWeight:700,color:'#065f46'}}>🎉 {h.name}</span></div>)}
                        {(type==='off'||type==='sunday')&&!dayE.length&&<div className={type==='sunday'?'sun-pill':'off-pill'}>{type==='sunday'?'No classes — Sunday':'No classes scheduled'}</div>}
                        {items.map((item,idx)=>{
                          if(item.type==='lunch') return <div key="lunch" className="lunch-pill">🍽 Lunch {lunchStart&&`${lunchStart}${lunchEnd?` – ${lunchEnd}`:''}`}</div>;
                          const e=item.e;
                          if(e.isActivity) return (
                            <div key={idx} className="period-pill">
                              <span className="period-num act">🏃</span>
                              <div className="period-info">
                                <div className="period-subj" style={{color:ACTIVITY_COLOR}}>🏃 {e.activityType||'Activity'}</div>
                                <div className="period-meta">{tName(e.teacher)&&tName(e.teacher)!=='—'?tName(e.teacher)+' · ':''}{e.startTime&&<span style={{fontFamily:"'JetBrains Mono',monospace",fontSize:'.68rem'}}>{e.startTime}{e.endTime?` – ${e.endTime}`:''}</span>}</div>
                              </div>
                            </div>
                          );
                          const col=subjColor(e.subject,uniqSubjs);
                          return (
                            <div key={idx} className="period-pill">
                              <span className="period-num">{e.period}</span>
                              <div className="period-info">
                                <div className="period-subj" style={{color:col}}>{e.subject}</div>
                                <div className="period-meta">{tName(e.teacher)}{e.startTime&&<span style={{marginLeft:6,fontFamily:"'JetBrains Mono',monospace",fontSize:'.68rem'}}>{e.startTime}{e.endTime?` – ${e.endTime}`:''}</span>}</div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </div>
        </>
      )}

      {editOpen&&ReactDOM.createPortal(
        <div className="mb" onClick={()=>setEditOpen(false)}>
          <div className="mo" onClick={e=>e.stopPropagation()}>
            <div className="mo-hd">
              <div className="mo-title">Edit — {activeGrade?.name} / Section {activeSection}</div>
              <button className="mo-x" onClick={()=>setEditOpen(false)}><XMarkIcon/></button>
            </div>
            <div className="mo-bd">
              {lunchStart&&<div className="ln">🍽 Lunch break: <strong>{lunchStart}{lunchEnd?` – ${lunchEnd}`:''}</strong></div>}
              {hasOffRows&&<div className="off-warn">⚠️ Some entries are on off days — they will be removed on save.</div>}
              {copyDone&&<div className="copy-info">✓ Monday periods copied to all working days.</div>}

              <div className="edt">
                <div className="ehdr">
                  <span>No.</span><span>Day</span><span>Type</span><span>Subject / Activity</span>
                  <span>Start (AM/PM)</span><span>End (AM/PM)</span><span>Teacher</span><span/>
                </div>
                {editRows.map((row,i)=>{
                  const off=isOffDay(row.day);
                  return (
                    <div key={i} className={`erow${row.isActivity?' act-row':''}${off?' off-ecard':''}`}>
                      <input type="number" className="ei" value={row.period} min={1} onChange={e=>upd(i,'period',e.target.value)}/>
                      <div style={{display:'flex',flexDirection:'column',gap:2}}>
                        <select className={`es${off?' off-sel':''}`} value={row.day} onChange={e=>upd(i,'day',e.target.value)}>
                          {DAYS.map(d=><option key={d} value={d} disabled={isOffDay(d)}>{d}{isOffDay(d)?' (Off)':''}</option>)}
                        </select>
                        {off&&<span className="off-day-tag">⚠️ Off day</span>}
                      </div>
                      <div className="type-toggle">
                        <button type="button" className={`type-btn${!row.isActivity?' on-normal':''}`} onClick={()=>!row.isActivity||toggleType(i)} title="Normal period">📚</button>
                        <button type="button" className={`type-btn${row.isActivity?' on-activity':''}`} onClick={()=>row.isActivity||toggleType(i)} title="Co-curricular activity">🏃</button>
                      </div>
                      {row.isActivity?(
                        <select className="es act-sel" value={row.activityType} onChange={e=>upd(i,'activityType',e.target.value)}>
                          {ACTIVITY_TYPES.map(a=><option key={a} value={a}>{a}</option>)}
                          <option value="__custom__">Custom…</option>
                        </select>
                      ):(
                        <SubjectField row={row} i={i}/>
                      )}
                      <input type="time" className="ei" value={row.startTime||''} onChange={e=>upd(i,'startTime',e.target.value)}/>
                      <input type="time" className="ei" value={row.endTime||''} onChange={e=>upd(i,'endTime',e.target.value)}/>
                      <PersonnelSelect row={row} i={i}/>
                      <button className="erm" onClick={()=>del(i)}><XMarkIcon/></button>
                    </div>
                  );
                })}
              </div>

              <div className="mob">
                {editRows.map((row,i)=>{
                  const off=isOffDay(row.day);
                  return (
                    <div key={i} className={`ecard${off?' off-ecard':''}${row.isActivity?' act-ecard':''}`}>
                      <div className="ecr">
                        <div className="ecf"><label className="ecl">Period</label><input type="number" className="ei" value={row.period} min={1} onChange={e=>upd(i,'period',e.target.value)}/></div>
                        <div className="ecf">
                          <label className="ecl">Day</label>
                          <select className={`es${off?' off-sel':''}`} value={row.day} onChange={e=>upd(i,'day',e.target.value)}>
                            {DAYS.map(d=><option key={d} value={d} disabled={isOffDay(d)}>{d}{isOffDay(d)?' (Off)':''}</option>)}
                          </select>
                          {off&&<span className="off-day-tag">⚠️ Off day</span>}
                        </div>
                        <div className="ecf ecfull">
                          <label className="ecl">Period Type</label>
                          <div className="type-toggle">
                            <button type="button" className={`type-btn${!row.isActivity?' on-normal':''}`} style={{flex:1,justifyContent:'center'}} onClick={()=>!row.isActivity||toggleType(i)}>📚 Normal Period</button>
                            <button type="button" className={`type-btn${row.isActivity?' on-activity':''}`} style={{flex:1,justifyContent:'center'}} onClick={()=>row.isActivity||toggleType(i)}>🏃 Activity Period</button>
                          </div>
                        </div>
                        {row.isActivity?(
                          <div className="ecf ecfull"><label className="ecl">Activity Type</label><select className="es act-sel" value={row.activityType} onChange={e=>upd(i,'activityType',e.target.value)}>{ACTIVITY_TYPES.map(a=><option key={a} value={a}>{a}</option>)}</select></div>
                        ):(
                          <div className="ecf ecfull"><label className="ecl">Subject</label><SubjectField row={row} i={i} className="es"/></div>
                        )}
                        <div className="ecf"><label className="ecl">Start</label><input type="time" className="ei" value={row.startTime||''} onChange={e=>upd(i,'startTime',e.target.value)}/></div>
                        <div className="ecf"><label className="ecl">End</label><input type="time" className="ei" value={row.endTime||''} onChange={e=>upd(i,'endTime',e.target.value)}/></div>
                        <div className="ecf ecfull"><label className="ecl">Teacher <span style={{fontWeight:400,fontSize:'.65rem',color:'#b0b5cc'}}>(optional)</span></label><PersonnelSelect row={row} i={i}/></div>
                      </div>
                      <div className="ecft"><button className="erm" onClick={()=>del(i)} style={{width:'auto',padding:'4px 10px',gap:4,fontSize:'.72rem'}}><XMarkIcon/>Remove</button></div>
                    </div>
                  );
                })}
              </div>

              <div style={{display:'flex',alignItems:'center',flexWrap:'wrap',gap:0,marginTop:8}}>
                <button className="addbtn" onClick={add}><PlusIcon/>Add Period</button>
                <button className="addactbtn" onClick={addActivity}><PlusIcon/>Add Activity Period</button>
                <button className="copybtn" onClick={copyMondayToAll} disabled={mondayCount===0}>
                  <DocumentDuplicateIcon/>Copy Monday to All
                  {mondayCount>0&&<span style={{fontSize:'.68rem',background:'#8b5cf6',color:'white',padding:'1px 6px',borderRadius:99,marginLeft:2}}>{mondayCount}</span>}
                </button>
              </div>
            </div>
            <div className="mo-ft">
              <button className="btn btn-ghost" onClick={()=>setEditOpen(false)}>Cancel</button>
              <button className="btn btn-green" onClick={save} disabled={saving}><CheckCircleIcon/>{saving?'Saving…':'Save Timetable'}</button>
            </div>
          </div>
        </div>
      ,document.body)}
    </div>
  );
}